import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { useTranslation } from 'react-i18next';

const ContentForm: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <OpForm.TextAreaInput rows={30} name="content" label={t('agreement.form.content')} />
        </>
    );
};

export default ContentForm;
